import {
    Box,
    Divider,
    Grid,
    InputAdornment,
    InputLabel,
    List,
    ListItem,
    ListItemSecondaryAction,
    ListItemText,
    Switch,
    TextField,
    Typography,
  } from "@mui/material";
  import React, { useEffect, useState } from "react";
  import OrderServices from "../../../api/orderServices/order.index";
  import { Controller, useForm } from "react-hook-form";
  import { SuccessToaster } from "../../../components/Toaster";
  import { SecondaryButton } from "../../../components/Buttons";
  
  const initialColors = [
    { name: "white", color: "#fff", enabled: true },
  
    { name: "lightgreen", color: "#80C670", enabled: true },
    { name: "purple", color: "#726DE8", enabled: false },
    { name: "darkgreen", color: "#272e26", enabled: false },
    { name: "blue", color: "#194b86", enabled: false },
    { name: "black", color: "#000", enabled: false },
  ];
 

const customColors = [
  { color: "#F7D560", enabled: false },
  { color: "#FFB300", enabled: false },
  { color: "#43A047", enabled: false },
  { color: "#7CB342", enabled: false },
  { color: "#E64A19", enabled: false },
  { color: "#5D4037", enabled: false },
  { color: "#546E7A", enabled: false },
  { color: "#001A66", enabled: false },
  { color: "#000000", enabled: false },
  { color: "#1A263D", enabled: false },
  { color: "#D9005D", enabled: false },
  { color: "#8E44AD", enabled: false },
  { color: "#2980B9", enabled: false },
  { color: "#009EE3", enabled: false },
  { color: "#00897B", enabled: false },
  { color: "#FFFFFF", enabled: false }
];


  
  const initialItems = [
    { name: "Standard", value: "" },
    { name: "Premium", value: "" },
    { name: "Half Intensity", value: "" },
    { name: "Half Tone", value: "" },
  ];
  
  const Colors = () => {
    const {
      register,
      handleSubmit,
      formState: { errors },
      control,
      setValue,
      getValues,
    } = useForm();
  
    const [items, setItems] = useState(initialItems);
  
  
    const handleTextChange = (index, event) => {
      const newValue = event.target.value;
      setItems((prevItems) =>
        prevItems.map((item, i) =>
          i === index ? { ...item, value: newValue } : item
        )
      );
    };
  
    const [colors, setColors] = useState(initialColors);
  
    const handleSwitchToggle = (index) => {
      setColors((prevColors) =>
        prevColors.map((item, i) =>
          i === index ? { ...item, enabled: !item.enabled } : item
        )
      );
    };
    const handleSwitchToggle2 = (index) => {
        setTextColors((prevColors) =>
          prevColors.map((item, i) =>
            i === index ? { ...item, enabled: !item.enabled } : item
          )
        );
      };
    const [emirates, setEmirates] = useState([]);
    const [standardPrice, setStandardPrice] = useState(0);
    const [orderLimit, setOrderLimit] = useState(0);
    const [textColors, setTextColors] = useState(customColors)
  
    const handleChange = (e, item) => {
      console.log(e.target.value);
      console.log(item);
      handleChargeChange(item?._id, e.target.value);
    };
  
    const handleChargeChange = (id, newCharge) => {
      setEmirates((prevEmirates) => {
        const updatedEmirates = prevEmirates.map((item) =>
          item._id === id ? { ...item, charge: newCharge } : item
        );
        console.log(`Updated charge for id ${id}: ${newCharge}`);
        console.log("Updated emirates array:", updatedEmirates);
        return updatedEmirates;
      });
    };
  
    const getPricing = async () => {
      try {
        let params = {};
        const { data } = await OrderServices.getPricing(params);
        console.log(data);
        setEmirates(data?.pricing?.delivery_charges);
        setOrderLimit(data?.pricing?.max_per_order);
        setStandardPrice(data?.pricing?.standard_price);
        setValue("standardPrice", data?.pricing?.standard_price);
        setColors(data?.pricing?.shirt_colors)
        setValue("limit", data?.pricing?.max_per_order);
        setItems([
          { name: "Standard", value: data?.pricing?.standard_price },
          { name: "Premium", value: data?.pricing?.premium_price },
          { name: "Half Intensity", value: data?.pricing?.full_intensity },
          { name: "Half Tone", value: data?.pricing?.halftone },
        ])
      } catch (error) {
        console.log(error);
      } finally {
      }
    };
  
    const updateSettings = async () => {
      console.log(items);
      let shirtObj = {
        standard_price: 0,
        premium_price: 0,
        halftone: 0,
        full_intensity: 0
      }
      for (let i = 0; i < items.length; i++) {
        const element = items[i];
        if (element.name == "Standard") {
          shirtObj.standard_price = element.value;
        }
        else if (element.name == "Premium") {
          shirtObj.premium_price = element.value;
        }
        else if (element.name == "Half Intensity") {
          shirtObj.full_intensity = element.value;
        }
        else if (element.name == "Half Tone") {
          shirtObj.halftone = element.value;
        }
      }
  
      try {
        let obj = {
          max_per_order: getValues("limit"),
          standard_price: getValues("standardPrice"),
          delivery_charges: emirates,
          shirt_colors: colors,
          standard_price: shirtObj.standard_price,
          premium_price: shirtObj.premium_price,
          halftone: shirtObj.halftone,
          full_intensity: shirtObj.full_intensity
        };
  
        const { message } = await OrderServices.updateSettings(obj);
        console.log(message);
        SuccessToaster(message);
      } catch (error) {
        console.log(error);
      } finally {
      }
    };
  
    useEffect(() => {
      getPricing();
    }, []);
    // Initialize form values
    useEffect(() => {
      emirates?.forEach((item) => {
        setValue(`charge${item.id}`, item.charge);
      });
    }, [emirates, setValue]);
  
    return (
      <Box
        sx={{
          mt: 10,
          p: 4,
  
          borderRadius: "8px",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        }}
        component="form"
        onSubmit={handleSubmit(updateSettings)}
      >
        <Grid container gap={2}>
        
          <Grid
            item
            md={5.9}
            sm={12}
  
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: "15px",
              p: 3,
              // backgroundColor: "#FFFFFF",
            }}
          >
            <Typography sx={{ fontWeight: "bold" }}>T-Shirt Colors</Typography>
            <Divider />
            <List>
              {colors?.map((item, index) => (
                <ListItem
                  key={index}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  {/* Color Label */}
                  <Box
                    sx={{
                      width: "16px",
                      height: "16px",
                      backgroundColor: item.color,
                      borderRadius: "50%",
                      marginRight: "10px",
                    }}
                  />
                  {/* Color Name */}
                  <ListItemText sx={{ textTransform: 'capitalize' }} primary={item.name} />
  
                  {/* Switch Button */}
                  <ListItemSecondaryAction>
                    <Switch
                      edge="end"
                      color="primary"
                      disabled={item?.name.toLowerCase() == 'white'}
                      checked={item.enabled}
                      onChange={() => handleSwitchToggle(index)}
                    />
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
            </List>
          </Grid>
          <Grid
            item
            md={5.9}
            sm={12}
  
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: "15px",
              p: 3,
              // backgroundColor: "#FFFFFF",
            }}
          >
            <Typography sx={{ fontWeight: "bold" }}>Text Colors</Typography>
            <Divider />
            <Grid container spacing={2}>
  {/* First Section */}
  <Grid item xs={12} md={6}>
    <List>
      {textColors?.slice(0, 6).map((item, index) => (
        <ListItem
          key={`section1-${index}`}
          sx={{ display: "flex", alignItems: "center" }}
        >
          {/* Color Label */}
          <Box
            sx={{
                width: "25px",
                height: "25px",
              backgroundColor: item.color,
              borderRadius: "50%",
              marginRight: "10px",
            }}
          />
          {/* Color Name */}
          <ListItemText sx={{ textTransform: 'capitalize' }} primary={item.name} />
          {/* Switch Button */}
          <ListItemSecondaryAction>
            <Switch
              edge="end"
              color="primary"
              checked={item.enabled}
              onChange={() => handleSwitchToggle2(index)}
            />
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  </Grid>

  {/* Second Section */}
  <Grid item xs={12} md={6}>
    <List>
      {textColors?.slice(6, 12).map((item, index) => (
        <ListItem
          key={`section2-${index}`}
          sx={{ display: "flex", alignItems: "center" }}
        >
          {/* Color Label */}
          <Box
            sx={{
              width: "25px",
              height: "25px",
              backgroundColor: item.color,
              borderRadius: "50%",
              marginRight: "10px",
            }}
          />
          {/* Color Name */}
          <ListItemText sx={{ textTransform: 'capitalize' }} primary={item.name} />
          {/* Switch Button */}
          <ListItemSecondaryAction>
            <Switch
              edge="end"
              color="primary"
              checked={item.enabled}
              onChange={() => handleSwitchToggle2(index + 6)} // Adjust index for the second section
            />
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  </Grid>
</Grid>
          </Grid>
        </Grid>
  
        {/* Submit Button Section */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
          <SecondaryButton
            type="submit"
            sx={{
              backgroundColor: "#1F5591",
              color: "white",
              fontWeight: "bold",
              p: "10px 20px",
              "&:hover": {
                backgroundColor: "#174175",
              },
            }}
            title="Update Colors"
          ></SecondaryButton>
        </Box>
      </Box>
    );
  };
  
  export default Colors;
  